module.exports = __webpack_public_path__ + "img/city.039308eb.jpg";